import { TitleWithBody } from "./PageBuilder/TitleWithBody";
import { RichTextSection } from "./PageBuilder/RichTextSection";
import { Stats } from "./PageBuilder/Stats";
import { Gallery } from "./PageBuilder/Gallery";

const TITLE_WITH_BODY = "titleWithBody";
const RICH_TEXT = "richTextWithHeader";
const STATS = "stats";
const GALLERY = "gallery";

const getSectionComponent = (component) => {
  switch (component._type) {
    case TITLE_WITH_BODY:
      return <TitleWithBody key={component._key} data={component} />;
    case RICH_TEXT:
      return <RichTextSection key={component._key} data={component} />;
    case STATS:
      return <Stats key={component._key} data={component} />;
    case GALLERY:
      return <Gallery key={component._key} data={component} />;
    default:
      return <p>Type not found</p>;
  }
};

function PageBuilder({ pageBuilderComponents }) {
  return <>{pageBuilderComponents.map((component) => getSectionComponent(component))}</>;
}

export default PageBuilder;
